import { HttpClient } from '@angular/common/http';
import { Component, DOCUMENT, inject } from '@angular/core';
import { Router } from '@angular/router';
import { injectRouteParam } from '@app/signals';
import { NO_AUTH_CONTEXT } from '@app/tokens';
import { catchError, firstValueFrom, map, of } from 'rxjs';

@Component({
  selector: 'app-tc',
  templateUrl: './tc.component.html',
})
export class TcComponent {
  private document = inject(DOCUMENT);
  private router = inject(Router);
  private http = inject(HttpClient);
  tenantParam = injectRouteParam('tenant');

  constructor() {
    this.loadTermsAndConditions();
  }

  loadTermsAndConditions() {
    const tenantId = this.tenantParam()?.toUpperCase() ?? 'NONE';
    this.doesTenantHaveTC(tenantId).then(exists => {
      if (exists) {
        this.redirectToTermsAndCondition(tenantId);
      } else {
        this.redirectToLogin();
      }
    });
  }

  async doesTenantHaveTC(tenantId: string) {
    return firstValueFrom(
      this.http
        .get<Blob>(this.getDocUrl(tenantId), {
          context: NO_AUTH_CONTEXT,
          responseType: 'blob' as 'json',
        })
        .pipe(
          map(() => true),
          catchError(() => of(false)),
        ),
    );
  }

  redirectToTermsAndCondition(tenantId: string) {
    this.document.location.href = this.getDocUrl(tenantId);
  }

  redirectToLogin() {
    this.router.navigate(['/login']);
  }

  private getDocUrl(tenantId: string) {
    return `/public/docs/${tenantId.toLowerCase()}/tc.pdf`;
  }
}
